var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-benefits-page"},[_c('div',{staticClass:"page-header"},[_c('div',{staticClass:"page-title"},[_vm._v("会员权益")])]),_c('picture',[_c('img',{staticClass:"img",attrs:{"src":"https://assetsprod.onitsukatiger.com/assets/wechat/usergw/user.png","alt":""}})])])
}]

export { render, staticRenderFns }